module.exports = __webpack_public_path__ + "static/media/news.4620c3aa.png";